// src/utils/petals.utils.ts
export const calculatePetals = (amount?: number): number => {
  if (!amount || amount < 1000) return 0;
  // Use Math.floor for whole numbers only, no rounding
  return Math.floor(amount / 1000);
};

export const calculateAmountFromPetals = (petals: number): number => {
  return petals * 1000;
};

// Helper to format display
export const formatPetalDisplay = (amount?: number): string => {
  if (!amount) return "0 petals";
  const petals = calculatePetals(amount);
  return `${petals} petal${petals !== 1 ? "s" : ""}`;
};
